module.exports = __webpack_public_path__ + "assets/img/7f70-lu.svg";